import createReactClass from 'create-react-class';
'use strict';

// Import Libraries
import React from 'react';
import PropTypes from 'prop-types';
// Import JSX Modules
import DecapitalisedTitle from '../_utils/decapitalised-title';
import AppleDeviceNameCapitaliser from '../_utils/apple-device-name-capitaliser';
import FilterColorCriteron from './filter-color-criteron';
import FilterImageCriteron from './filter-image-criteron';
import FilterTextCriteron from './filter-text-criteron';
import FilterComparison from './filter-comparison';
// Import JS Modules
import genericHelpers from '../_utils/generic-helpers';
import filterPropertyTitleToUpperCase from '../_utils/product-filter-property-title-to-uppercase';

const Filter = createReactClass({
  getInitialState() {
    return {
    };
  },
  render() {
    const $criteria = this.props.level.options.map((criteron, i) => {
      const disabled = !this.props.currentProducts.some(product => product.filters[this.props.level.title] === criteron.title);

      return React.createElement(this.selectorType(), {
        key: criteron.title + i,
        title: filterPropertyTitleToUpperCase(criteron.title),
        image: criteron.image,
        selected: criteron.title === this.props.selected,
        disabled,
        onSelected: this.handleCriteronSelected,
        onMouseEnter: this.handleCriteronOnMouseEnter,
        onMouseLeave: this.handleCriteronOnMouseLeave
      });
    });

    return (
      <div className="clearfix filter filter__multiple-choice">
        <div className="d-flex align-content-center title-and-value mw-100">
          <strong className="title"><DecapitalisedTitle>{genericHelpers.tidyTitleFilter(this.props.level.title)}</DecapitalisedTitle>:</strong>
          <FilterComparison
            fields={this.props.level.comparison_fields}
            options={this.props.level.options}
            products={this.props.products}
            deliveryOptions={this.props.deliveryOptions}
          />
          {this.renderLabel()}
        </div>
        <ul className="list-inline">
          {
            $criteria.map(($criteron, i) => (
              <li className="list-inline-item mw-100" key={i}>
                {$criteron}
              </li>
            ))
          }
        </ul>
      </div>
    );
  },
  renderLabel() {
    const label = filterPropertyTitleToUpperCase(this.state.label || this.props.selected);
    if (label) {
      return (
        <span className="value text-truncate" key={label}>
          <DecapitalisedTitle>
            <AppleDeviceNameCapitaliser>
              {label}
            </AppleDeviceNameCapitaliser>
          </DecapitalisedTitle>
        </span>
      );
    }

    if (this.context.validateOptionsChosen) {
      return (
        <span className="no-capitalize error-text">
          Choose an option &nbsp;
          <i className="validation-marker validation-marker-error fas fa-exclamation-circle">
            <span className="sr-only">Please select an option</span>
          </i>
        </span>
      );
    }

    return (
      <span className="no-capitalize">
        Choose an option
      </span>
    );
  },
  selectorType() {
    if (this.isColor())
      return FilterColorCriteron;

    if (this.isImage())
      return FilterImageCriteron;

    return FilterTextCriteron;
  },
  isColor() {
    const name = this.props.level.title.toLowerCase();

    return ['color', 'colour'].some(term => name === term);
  },
  isImage() {
    const [option] = this.props.level.options;

    return option && option.image && this.context.useIconsNotTextInFilters;
  },
  handleCriteronOnMouseEnter(label) {
    this.setState({ label: label });
  },
  handleCriteronOnMouseLeave() {
    this.setState({ label: undefined });
  },
  handleCriteronSelected(filterCriteron) {
    this.props.onCriteronSelected(this.props.level.title, (c => c && c.toLowerCase())(filterCriteron));
  }
});

Filter.contextTypes = {
  validateOptionsChosen: PropTypes.bool,
  useIconsNotTextInFilters: PropTypes.bool
};

export default Filter;
